import { render } from "./HoursIcon.vue?vue&type=template&id=99f9dfd0&scoped=true"
import script from "./HoursIcon.vue?vue&type=script&lang=js"
export * from "./HoursIcon.vue?vue&type=script&lang=js"

import "./HoursIcon.vue?vue&type=style&index=0&id=99f9dfd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f9dfd0"],['__file',"src/components/ChatWidget/ChatIcons/HoursIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99f9dfd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99f9dfd0', __exports__)) {
    api.reload('99f9dfd0', __exports__)
  }
  
  module.hot.accept("./HoursIcon.vue?vue&type=template&id=99f9dfd0&scoped=true", () => {
    api.rerender('99f9dfd0', render)
  })

}


export default __exports__